import React from 'react';
import classNames from 'classnames';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import { ActivityFeedSummaryItem } from 'types/ActivityFeed/summary';
import xss from 'xss';

import { determineIconAndClassName } from './ActivityFeedIcons';
import ActivityFeedTime from './ActivityFeedTime';

type Props = {
  colorStyle?: string;
  iconStyle?: string;
  toolbarStyle?: string;
  withActivityTime?: boolean;
  forToolbar?: boolean;
  item: ActivityFeedSummaryItem;
};

const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(1),
  },
  body: {
    wordBreak: 'break-word',
  },
}));

function ActivityFeedSummary({ colorStyle, iconStyle, toolbarStyle, item, withActivityTime, forToolbar }: Props) {
  const classes = useStyles();
  const iconClassNameTuple = determineIconAndClassName(item.kind);
  const icon = React.cloneElement(iconClassNameTuple.icon, {
    className: classNames(colorStyle, iconStyle),
  });

  return (
    <Grid container>
      <Grid item xs={1} className={forToolbar ? toolbarStyle : classes.icon}>
        {icon}
      </Grid>
      <Grid item xs>
        <Typography
          variant="body1"
          className={`${colorStyle} ${classes.body}`}
          dangerouslySetInnerHTML={{ __html: xss(item.message) }}
        />
        {withActivityTime && <ActivityFeedTime colorStyle={colorStyle} activityTime={item.when} splitTime={false} />}
      </Grid>
    </Grid>
  );
}

export default ActivityFeedSummary;
